module.exports = __webpack_public_path__ + "static/color-code-game-3d34cd8a7276fdfb489bc596962b9f3a.gif";